'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import GridView from '@/components/BlogPage/PostsList/GridView';
import Image from '@/components/Image';
import Link from '@/components/Link';
import { LatestBlogPostsData } from '@/components/shared/LatestBlogPosts/types';
import ShowMoreFilledButton from '@/components/shared/ShowMoreFilledButton';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { useRelevantBlogPosts } from '@/hooks/blog/useRelevantBlogPosts';
import { useCustomCursor } from '@/hooks/useCustomCursor';
import css from './style.module.scss';
interface Props {
  className?: string;
  data: LatestBlogPostsData;
  htmlId?: string;
}
const LatestBlogPosts: FC<Props> = t0 => {
  const $ = _c(30);
  const {
    className,
    data,
    htmlId: t1
  } = t0;
  const htmlId = t1 === undefined ? "latest-blog-posts" : t1;
  const {
    title,
    linkLabel: t2,
    showMoreLabel: t3,
    tags
  } = data;
  const linkLabel = t2 === undefined ? "Taste our blog" : t2;
  const showMoreLabel = t3 === undefined ? "Load more articles" : t3;
  const {
    setCursorVariant,
    setIsCursorVisible
  } = useCustomCursor();
  let t4;
  if ($[0] !== tags) {
    t4 = {
      tags
    };
    $[0] = tags;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    posts,
    hasMore,
    showMore
  } = useRelevantBlogPosts(t4);
  if (!posts?.length) {
    return null;
  }
  let t5;
  if ($[2] !== className) {
    t5 = clsx(css.section, "container", className);
    $[2] = className;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== setCursorVariant) {
    t6 = () => setCursorVariant("lottie-article-green");
    $[4] = setCursorVariant;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== title) {
    t7 = <Typography uppercase={true} className={css.title} variant="h2" tag="h2"><StrapiRichContent content={title} /></Typography>;
    $[6] = title;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== linkLabel) {
    t8 = <Typography uppercase={true} className={css.linkLabel} variant="body-m" tag="span">{linkLabel}</Typography>;
    $[8] = linkLabel;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Image src="/assets/icons/arrow.svg" alt="" width={18} height={18} className={css.linkArrow} />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <Link href="/blog" className={css.link}>{t8}{t9}</Link>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t7) {
    t11 = <div className={css.header}>{t7}{t10}</div>;
    $[13] = t10;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== posts || $[17] !== setIsCursorVisible) {
    t12 = <GridView posts={posts} setIsCustomCursorVisible={setIsCursorVisible} />;
    $[16] = posts;
    $[17] = setIsCursorVisible;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== hasMore || $[20] !== showMore || $[21] !== showMoreLabel) {
    t13 = hasMore ? <ShowMoreFilledButton className={css.showMoreButton} label={showMoreLabel} onClick={showMore} /> : null;
    $[19] = hasMore;
    $[20] = showMore;
    $[21] = showMoreLabel;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== htmlId || $[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== t5 || $[28] !== t6) {
    t14 = <section className={t5} id={htmlId} onMouseEnter={t6}>{t11}{t12}{t13}</section>;
    $[23] = htmlId;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t5;
    $[28] = t6;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default LatestBlogPosts;